export default {
  alerts: {},
  networks: [],
  wlStatistics: {},
  alertRadarPoints: [],
  hostsStat: []
};
